// extracted by mini-css-extract-plugin
module.exports = {"titre":"decouvrir-module--titre--2Wy-W","contenu":"decouvrir-module--contenu--1dR7H","lien":"decouvrir-module--lien--2B4Jq"};